import { render, staticRenderFns } from "./RamsShow.vue?vue&type=template&id=7ddd0f15&"
import script from "./RamsShow.vue?vue&type=script&lang=js&"
export * from "./RamsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports